import Immutable from 'immutable';

import {
	createModuleState,
	EntitySearchAndDetailModel,
	styled,
	DefinitionUtils,
	EntityDetailModel,
	FormDefinition as Form,
	FormItemDefinition as FormItem,
	// CrossDefinition as Cross,
	// FileInputDefinition as FileInput,
	TabPaneDefinition as TabPane,
	BoxDefinition as Box,
	TabDefinition as Tab,
	ModalDefinition as Modal,
	ContainerDefinition as Container,
	FileInputDefinition as FileInput,
	showMessageBox,
	REPORTED_EXCEPTION,
	webapi,
	ModuleHeader,
	ModuleHeaderItem,
	Icon,
	createModelForState,
	CentererDefinition as Centerer,
	ButtonDefinition as Button,
	CrossDefinition as Cross,
	Button as ButtonComponent,
	TabularInputDefinition as TabularInput,
	MessageDefinition,
	ValueValidator,
	ContextValidator,
	NumberUtils,
	NumberInput,
	DateUtils,
	updateEntityTimestamp,
} from 'ps-gui';

import { getFormItemLabel, getPhrase } from '../../data/phrases';
import {
	createSearchModel, formatHtml, getNsndTokenFilterProcessor, getSearchDefinition, parseRoleId, processModifications, validateRuntime, validateSharePct,
} from '../utils';
import { CellError, CellFiller, CellMainText } from '../portalresultsetmodule';
import Message from '../../blocks/message';
import { StatusBubble } from '../submissioncomponents';
import CorrectionInput from './correctioninput';
import memoizeOne from 'memoize-one';
import { DisclaimerWrapper, getCorrectionMessageDefinition, renderTotalTable, searchTabCustomResultProps, showCorrectionDialog, totalSaleMap2Array } from './correctionutils';
import { getLookup } from '../../data/lookup';
import { getLanguageId } from '../../data/session';
import LatestStatus from './lateststatus';

const EMPTY_MAP = Immutable.Map({});
const EMPTY_LIST = Immutable.List([]);
const EMPTY_STATE = createModuleState('AffirmationSubmission');


const FREE_TEXT_PREFIX = '#';

export default class AffirmationSubmissionModel {
	#data;

	constructor(data) {
		this.#data = data || EMPTY_MAP;
	}

	#setProperty(name, value) {
		if (Array.isArray(name)) {
			return new AffirmationSubmissionModel(this.#data.setIn(name, value));
		} else {
			return new AffirmationSubmissionModel(this.#data.set(name, value));
		}

	}

	#setInitialized() {
		return new AffirmationSubmissionModel(this.#data.set('initialized', true));
	}

	/**
	 *
	 * @returns {number} cas posledni zmeny jazyka zachycene timto modelem
	 */
	getLanguageTimestamp() {
		return this.#data.get('languageTimestamp') || 0;
	}

	isDetailOpen() {
		return this.#data.getIn(['esad', 'data', 'isDetailOpen']);
	}

	async openNewSubmission() {
		let esad = this.getEntitySearchAndDetail();
		esad = await esad.showNewDetail();
		return this.setEntitySearchAndDetail(esad);
	}

	/*getRoleId() {
		return this.#data.get('roleId');
	}

	getDistributionPeriodId() {
		return this.#data.get('distributionPeriodId');
	}

	setDistributionPeriodId(value) {
		return this.#setProperty('distributionPeriodId', value);
	}

	setRoleId(value) {
		console.log('setRoleId', value);
		return this.#setProperty('roleId', value);
	}*/

	/**
	 * kontroluje, zda se nezmenil jazyk, a pokud ano, nacte znovu data, aby byla v novem jazyce.
	 * volano z modulu pri componentDidUpdate a v pripade, ze se zmenil GlobalContext, tak i componentDidUpdate
	 *
	 * @param globalContext {GlobalContextModel}
	 */
	async checkGlobalContextChange(globalContext) {
		console.log('checkGlobalContetxtChange');
		if (!globalContext) {
			return this;
		}
		const gcLangId = globalContext.getLanguageId();
		const langId = this.#data.get('langId');
		if (gcLangId === langId) {
			return this;
		}
		return (await this.initialize(globalContext)).#setProperty('languageTimestamp', new Date().getTime());
	}

	initialize(globalContext) {
		console.log('inicializuji');
		let model = this;
		// model = model.setRoleId(getDefaultValue('affirmationSubmissionPartyRole'));
		// model = model.setDistributionPeriodId(getDefaultValue('affirmationDistributionPeriod'));
		let srch = createSearchModel('/api/dq/sv_affirmation_submission').setProcessFilter(processSearchFilter);
		return model.setEntitySearchAndDetail(
			new EntitySearchAndDetailModel()
				.setSearch(srch)
				.setDetail(getDetailModel())
				.onBeforeHideDetail(async model => {
					if (model.getDetail().isModified()) {
						const dlgRes = await showMessageBox(getPhrase('reallyLeaveModifiedAffirmationSubmission'), {type: 'confirm', yesIsNegative: true});
						return dlgRes === 'yes';
					}
				})
				.setNewRowMode(EntitySearchAndDetailModel.NEW_ROW_MODE_LOAD_NULL_ID)
				.setEntityName('affirmationSubmission')
		).#setProperty('langId', globalContext.getLanguageId()).#setInitialized();
	}

	async loadData() {
		return this;
	}

	setEntitySearchAndDetail(model) {
		return new AffirmationSubmissionModel(this.#data.set('esad', model.getState()));
	}

	getEntitySearchAndDetail() {
		return createModelForState(this.#data.get('esad'));
	}

	getData() {
		return this.#data;
	}

	getState() {
		return EMPTY_STATE.set('data', this.#data);
	}
}



async function uploadFile(files) {
	if (!files || files.length === 0) {
		return;
	}

	if (files.length > 1) {
		showMessageBox(getPhrase('selectOneFile'));
		return;
	}

	const file = files[0];
	const uploadedFile = await webapi.upload('/api/file', file);
	if (uploadedFile === REPORTED_EXCEPTION) {
		return;
	}
	return uploadedFile;
}

async function importAffirmationAttachment(ctx, value) {
	ctx.setRootProperty(['tmp', 'uploadButtonsHidden'], true);
	const stats = getTotalStats(ctx);
	if (stats.hasData) {
		const dlgRes = await showMessageBox(getPhrase('affirmationImport.existingDataWillBeReplaced'), {type: 'confirm'});
		if (dlgRes !== 'yes') {
			ctx.setRootProperty(['tmp', 'uploadButtonsHidden'], false);
			return;
		}
	}


	const uploadedFile = await uploadFile(value);
	console.log('uploadedFile', uploadedFile);
	if (!uploadedFile) {
		ctx.setRootProperty(['tmp', 'uploadButtonsHidden'], false);
		return;
	}
	const importId = await webapi.execute('/api/affirmation/importaffirmationattachment', {
		fileId: uploadedFile.fileId,
		distributionPeriodId: ctx.getProperty('distributionPeriodId'),
		producerId: ctx.getProperty('partyId'),
		_pendingRequestMessage: getPhrase('importingFile').replace('$fileName', uploadedFile.originalFileName)
	});
	if (importId === REPORTED_EXCEPTION) {
		ctx.setRootProperty(['tmp', 'uploadButtonsHidden'], false);
		return;
	}
	const res = await webapi.execute('/api/proc/api_affirmations/consolidateAffirmationAttachmentImport', {
		importId,
		_pendingRequestMessage: getPhrase('consolidatingFile').replace('$fileName', uploadedFile.originalFileName)
	});
	if (res === REPORTED_EXCEPTION) {
		ctx.setRootProperty(['tmp', 'uploadButtonsHidden'], false);
		return;
	}
	if (res.status === 'importHasErrors') {
		showImportErrors(ctx, importId, uploadedFile.originalFileName);
	} else {
		await showMessageBox(getPhrase('importSuccessful').replace('$fileName', uploadedFile.originalFileName));
		ctx.setModel(await ctx.getModel().reload());
	}
	ctx.setRootProperty(['tmp', 'uploadButtonsHidden'], false);

}

function renderErrorCell(name) {
	return (cell, row, colIndex) => {
		const err = row.get('err_' + name);
		const str = row.get('str_' + name);
		return (
			<CellFiller background={err ? '#DC000034' : null} padding="8px 12px">
				<CellMainText>{cell || str || '\u0020'}</CellMainText>
				<CellError>{err ? getPhrase('cellError.' + err) : null}</CellError>
			</CellFiller>
		);
	};
}


const stgImportErrorCustomResultProps = {
	cellPadding: '0px',
	cellRendererMap: {
		'row_id': (cell, row, colIndex) => {
			return <CellFiller padding="8px 12px">{cell + row.get('base_row_offset')}</CellFiller>;
		},
		title: renderErrorCell('title'),
		production_year: renderErrorCell('production_year'),
		share_pct: renderErrorCell('share_pct'),
		runtime: renderErrorCell('runtime'),
		type: renderErrorCell('type'),
		channel: renderErrorCell('channel'),
		broadcast_time: renderErrorCell('broadcast_time'),
		physical_sale_income: renderErrorCell('physical_sale_income'),
		digital_sale_income: renderErrorCell('digital_sale_income'),
		currency: renderErrorCell('currency'),
		attendance: renderErrorCell('attendance'),
		note: renderErrorCell('note'),
	},
	withNewEntityButton: false,
	defaultColumnWidths: {
		row_id: '100px',
		'country_id': '100px',
		'attendance': '110px',
		'release_date': '140px'
	},
	columnFilters: {
	}
};

function getImportErrorDialog() {
	const viewName = 'sv_stg_affirmation_attachment';
	const customResultProps = stgImportErrorCustomResultProps;

	return Modal(
		Box().setContent(
			getSearchDefinition(
				viewName,
				'/api/dq/' + viewName,
				[],
				'affirmationAttachment',
				['tmp'],
				true
			).setProps(ctx => {
				let fixedFilter = Object.assign({}, (ctx.getRootProperty(['tmp', viewName + '__params']) || EMPTY_MAP).toJS());
				return {
					fixedFilter,
					customResultProps
				};
			})
		).setWidth('calc( 100vw - 100px ) ')
			.setContentHeight('calc( 90vh - 100px ) ')
			.setHeader(ctx => getPhrase('importErrorHeader').replace('$fileName', (ctx.getRootProperty(['tmp', viewName + '__params']) || EMPTY_MAP).get('fileName')))
			.setContentOverflow('auto')
			.setRightHeaderContent(ctx => {
				return (
					<Icon
						name="delete"
						active
						onMouseDown={e => {
							ctx.setRootProperty(['tmp', viewName + '__params'], null);
							ctx.setRootProperty(['tmp', viewName], null);
							console.log(ctx.getData().toJS());
						}}
					/>
				);
			})
	).setVisible(ctx => ctx.getRootProperty(['tmp', viewName + '__params'])).setRootContainer(true);
}

function showImportErrors(ctx, importId, fileName) {
	const viewName = 'sv_stg_affirmation_attachment';
	ctx.setRootProperty(['tmp', viewName + '__params'], EMPTY_MAP.set('import_id', importId).set('fileName', fileName));
}


function isCreatable(ctx) {
	return ctx.getProperty('distributionPeriodId');
}




const lookupTitleChangeProcessor = {
	pressdata: {
		attributes: ['channel', 'broadcastStartTime', 'runtime', 'productionYear', 'affirmationRecordingTypeId', 'originalTitle'],
		setAttribute: (ctx, name, value) => {
			if (name === 'runtime' || name === 'productionYear') {
				value = parseInt(value);
				if (isNaN(value)) {
					value = null;
				}
			}
			ctx.setProperty(name, value);
		}
	},
	ufd: {
		attributes: ['attendance', 'releaseDate', 'originalTitle'],
		setAttribute: (ctx, name, value) => {
			if (name === 'attendance') {
				value = parseInt(value);
				if (isNaN(value)) {
					value = null;
				}
			}
			ctx.setProperty(name, value);
		}
	}
};

function parseTitle(value) {
	if (!value) {
		return {
			title: value,
			attributes: []
		};
	}
	if (value.charAt(0) === '#') { // freeTextPrefix
		return {
			title: value.substring(1),
			freeText: true
		};
	} else {
		const idx = value.indexOf('^');
		return {
			attributes: value.substring(0, idx).split(/\|/),
			title: value.substring(idx + 1)
		};
	}
}

function getLookupTitleChangeProcessor(type) {
	const attributeNames = lookupTitleChangeProcessor[type].attributes;
	const setAttribute = lookupTitleChangeProcessor[type].setAttribute;
	return (ctx, me, value) => {
		let pt = parseTitle(value);
		if (!pt.freeText) {
			const attrs = pt.attributes;
			for (let idx = 0; idx < attributeNames.length; idx++) {
				setAttribute(ctx, attributeNames[idx], attrs[idx]);
			}
			ctx.setProperty('isUnlocked', 'N');
		} else {
			ctx.setProperty('isUnlocked', 'Y');
		}
		ctx.setProperty('isan', '');
		ctx.setProperty('comments', '');
		ctx.setProperty('correction', '');
		ctx.setProperty('attachments', EMPTY_LIST);
		ctx.setProperty('title', pt.title);
	};
}

function isCinemaAttendanceLocked(ctx) {
	return ctx.getProperty('isUnlocked') !== 'Y';
}

function isBroadcastLocked(ctx) {
	return ctx.getProperty('isUnlocked') !== 'Y';
}

function getTabularInputKeySuffix(ctx) {
	return ctx.getRootProperty(['tmp', 'tiKeySuffix']) || 0;
}

function updateTabularInputKeySuffix(ctx) {
	ctx.setRootProperty(['tmp', 'tiKeySuffix'], new Date().getTime());
}



function getCinemaAttendanceIndexTimestamp(ctx) {
	return ctx.getRootProperty(['tmp', 'cinemaAttendanceIndexTimestamp']) || 0;
}

function getBroadcastIndexTimestamp(ctx) {
	return ctx.getRootProperty(['tmp', 'broadcastIndexTimestamp']) || 0;
}

function updateCinemaAttendanceIndexTimestamp(ctx) {
	ctx.setRootProperty(['tmp', 'cinemaAttendanceIndexTimestamp'], new Date().getTime());
}

function updateBroadcastIndexTimestamp(ctx) {
	ctx.setRootProperty(['tmp', 'broadcastIndexTimestamp'], new Date().getTime());
}

function getSaleIndexTimestamp(ctx) {
	return ctx.getRootProperty(['tmp', 'saleIndexTimestamp']) || 0;
}

function updateSaleIndexTimestamp(ctx) {
	ctx.setRootProperty(['tmp', 'saleIndexTimestamp'], new Date().getTime());
}

function copyAttributesToRow(ctx, attributes, src) {
	for (let i=0; i<attributes.length; i++) {
		const attr = attributes[i];
		ctx.setProperty(attr, src[attr]);
	}
}

/*
export async function showMessageBox(message, options) {
	var handle = sequence++;
	options = options || {};
	let _resolve;
	const res = new Promise(function(resolve) {
		_resolve = resolve;
	});
	const callback = function(res) {
		store.dispatch({
			type: 'messageBox.hideMessageBox',
			handle
		});
		_resolve(res);
	}
	store.dispatch({
		type: 'messageBox.showMessageBox',
		request: {
			handle,
			message,
			options,
			callback
		}
	});
	return res;
}

*/

export function getDistributionYearFromModelData(data) {
	return parseInt(data.getIn(['esad', 'data', 'detail', 'data', 'detail', 'distributionPeriodId']));
}

function getDistributionYear(ctx) {
	return parseInt(ctx.getRootProperty(['detail', 'distributionPeriodId']));
}

function validateProductionYear(ctx, year, releaseDate) {
	const distYear = getDistributionYear(ctx);
	const releaseYear = releaseDate ? parseInt(releaseDate.substring(0, 4)) : null;
	/*if (releaseYear) {
		return year > releaseYear ? getPhrase('productionYearMustNotBeAfterReleaseYear') : null;
	}*/
	const minYear = distYear - 51;
	const maxYear = releaseYear && releaseYear < distYear ? releaseYear : distYear;

	return year < minYear || year > maxYear ? getPhrase('publicationYearMustBeBetweenMinAndMax').replace('$min', minYear).replace('$max', maxYear) : null;
}

function createProductionYearValidator() {
	return ContextValidator((errors, ctx, itemName) => {
		ctx.updateData(true);
		const year = ctx.getProperty(itemName);
		const releaseDate = ctx.getProperty('releaseDate');
		const path = ctx.getFullPath().concat(itemName);
		errors.add(path, validateProductionYear(ctx, year, releaseDate), 'invalidYear');
	});
}

function normalizeTitle(title) {
	if (!title) {
		return '';
	}
	const lowerTitle = title.toLowerCase();
	return lowerTitle.replace(/[^a-z0-9]+/g, '').trim() || lowerTitle;
}

function updateSalesFromCinemaAttendanceAndBroadcasts(ctx) {
	const src = (ctx.getRootProperty(['detail', 'cinemaAttendance']) || EMPTY_LIST).filter(row => !row.get('_deleted') && row.get('title')).map(row => {
		return {
			year: row.get('productionYear'),
			title: row.get('title'),
			sharePct: row.get('sharePct'),
			affirmationRecordingTypeId: 'CNFLM'
		};
	}).toArray().concat((ctx.getRootProperty(['detail', 'broadcasts']) || EMPTY_LIST).filter(row => !row.get('_deleted') && row.get('title') && row.get('affirmationRecordingTypeId')).map(row => {
		return {
			year: row.get('productionYear'),
			title: row.get('title'),
			sharePct: row.get('sharePct'),
			affirmationRecordingTypeId: row.get('affirmationRecordingTypeId')
		};
	}).toArray());

	const salePath = ['detail', 'sales'];
	const currRows = (ctx.getRootProperty(salePath) || EMPTY_LIST);
	let currMap = {};
	currRows.forEach(row => {
		if (row.get('_deleted') || !row.get('title')) {
			return;
		}
		currMap[normalizeTitle(row.get('title')) + '/' + row.get('productionYear')] = true;
	});
	let newRows = [];
	src.forEach(row => {
		const exKey = normalizeTitle(row.title) + '/' + row.year;
		if (currMap[exKey]) {
			return;
		}
		currMap[exKey] = true;
		newRows.push({
			productionYear: row.year,
			title: row.title,
			sharePct: row.sharePct,
			affirmationRecordingTypeId: row.affirmationRecordingTypeId,
			currency: 'CZK',
			physicalSaleIncome: 0,
			digitalSaleIncome: 0
		});
	});
	if (newRows.length === 0) {
		showMessageBox(getPhrase('nowRowsAdded'));
		return;
	}
	ctx.setRootProperty(salePath, currRows.concat(Immutable.fromJS(newRows)));
	updateSaleIndexTimestamp(ctx);
	showMessageBox(getPhrase('countRowsAdded').replace('$count', newRows.length));

}

async function getCopyOfPreviousCinemaAttendances(ctx) {
	const partyId = ctx.getRootProperty(['detail', 'partyId']);
	const distributionPeriodId = ctx.getRootProperty(['detail', 'distributionPeriodId']);
	let rows = await webapi.execute('/api/proc/api_affirmations/getCopyOfPreviousCinemaAttendances', {
		tarDistPeriodId: distributionPeriodId,
		srcDistPeriodId: '' + (parseInt(distributionPeriodId) - 1),
		partyId
	});
	let currMap = {};
	const cinemaAttendancePath = ['detail', 'cinemaAttendance'];
	const currRows = (ctx.getRootProperty(cinemaAttendancePath) || EMPTY_LIST);
	currRows.forEach(row => {
		if (row.get('_deleted')) {
			return;
		}
		currMap[row.get('title')] = row.get('productionYear') || 1;
	});
	rows = rows.filter(row => {
		const exYear = currMap[row.title];
		return !exYear || row.productionYear != exYear;
	});
	if (rows.length === 0) {
		showMessageBox(getPhrase('noMatchingCinemaAttendancesFound'));
		return;
	}
	ctx.setRootProperty(cinemaAttendancePath, currRows.concat(Immutable.fromJS(rows)));
	updateCinemaAttendanceIndexTimestamp(ctx);
	showMessageBox(getPhrase('countRowsAdded').replace('$count', rows.length));
}

async function updateBroadcastsFromCinemaAttendance(ctx) {
	const ca = (ctx.getRootProperty(['detail', 'cinemaAttendance']) || EMPTY_LIST).filter(row => !row.get('_deleted')).map(row => {
		return {
			year: row.get('productionYear'),
			title: row.get('title'),
			sharePct: row.get('sharePct')
		};
	}).toArray();
	const pars = {
		distributionPeriodId: ctx.getRootProperty(['detail', 'distributionPeriodId']),
		rows: ca,
		_pendingRequestMessage: getPhrase('updatingBroadcastsFromCinemaAttendance')
	};
	let newRows = await webapi.execute('/api/proc/api_affirmations/getPressdataRowsMatchingTitleAndYear', pars);
	if (newRows === REPORTED_EXCEPTION) {
		return;
	}
	newRows = newRows || [];
	const broadcastPath = ['detail', 'broadcasts'];
	const currRows = (ctx.getRootProperty(broadcastPath) || EMPTY_LIST);
	let currMap = {};
	currRows.forEach(row => {
		if (row.get('_deleted')) {
			return;
		}
		currMap[row.get('title')] = row.get('productionYear') || 1;
	});
	newRows = newRows.filter(row => {
		const exYear = currMap[row.title];
		return !exYear;
	});
	if (newRows.length === 0) {
		showMessageBox(getPhrase('noMatchingProgrammesFound'));
		return;
	}
	ctx.setRootProperty(broadcastPath, currRows.concat(Immutable.fromJS(newRows)));
	updateBroadcastIndexTimestamp(ctx);
	showMessageBox(getPhrase('countRowsAdded').replace('$count', newRows.length));
}

function isSubmissionReadOnly(ctx) {
	return ctx.getRootProperty(['detail', 'readOnly']);
}

function createCorrectionInputDefinition(opts) {
	opts = opts || {};
	return FormItem('correction', 'custom')
		.setCustomInput(pars => {
			const ctx = pars.ctx;
			return (
				<CorrectionInput
					readOnly={pars.readOnly}
					value={pars.value}
					noButton={!ctx.getProperty('title')}
					text={opts.text}
					onMouseDown={async e => {
						const res = await showCorrectionDialog(ctx, ctx.getProperty('correction'), ctx.getProperty('attachments'), opts);
						if (res) {
							ctx.setProperty('attachments', res.get('attachments'));
							ctx.setProperty('isUnlocked', 'Y');
							pars.onChange(res.get('comments'));
						}
					}}
				/>
			);
		})
		.setWidth(opts.width || '64px')
		.setLabel('');
}

function createCorrectionRowValidator() {
	return ContextValidator((errors, ctx, itemName) => {
		if (!itemName || itemName === 'title' || itemName === 'correction') {
			if (ctx.getProperty('isUnlocked') === 'Y' && !ctx.getProperty('correction')) {
				console.log('ble = ', ctx.getData().toJS());
				errors.add(
					ctx.getFullPath().concat('title'),
					{
						type: 'error',
						code: 'unlockedNeedsCorrection',
						message: getPhrase('correctionReasonIsMandatory'),
						longMessage: getPhrase('correctionReasonIsMandatoryLong').replace('$title', ctx.getProperty('title')),
					}
				);
			} else {
				errors.add(ctx.getFullPath().concat('title'), null, 'unlockedNeedsCorrection');
			}
		}
	});
}

function editTabVisible(ctx) {
	const detail = ctx.getRootProperty('detail');
	return detail.get('id') && detail.get('isImported') === 'N' && !detail.get('readOnly');
}

function searchTabVisible(ctx) {
	const detail = ctx.getRootProperty('detail');
	return detail.get('id') && (detail.get('isImported') === 'Y' || detail.get('readOnly'));
}

function searchTabProps(ctx) {
	const detail = ctx.getRootProperty('detail');
	return {
		fixedFilter: {
			party_id: detail.get('partyId'),
			distribution_period_id: detail.get('distributionPeriodId'),
			role_type_id: detail.get('roleTypeId')
		},
		customResultProps: searchTabCustomResultProps
	};
}

function resolutionProps(ctx) {
	const detail = ctx.getRootProperty('detail');
	return {
		fixedFilter: {
			party_id: detail.get('partyId'),
			distribution_period_id: detail.get('distributionPeriodId'),
			role_type_id: detail.get('roleTypeId')
		},
		customResultProps: resolutionCustomResultProps
	};
}

const formatAmount = NumberUtils.getFixedDecimalFormatNumber(2);
const formatShare = NumberUtils.getFixedDecimalFormatNumber(2);
const formatNumber = NumberUtils.formatNumber;

const ConflictResolutionClosedMessage = styled.div`
	font-weight: 500;
	color: ${props => props.theme.errorColor};
	text-align: center;
	margin: 16px;
`;



let detailDefinition = Container([
	TabPane().setTabs([
		Tab('newAffirmationSubmission', () => getPhrase('newAffirmationSubmission')).setContent(
			Centerer(
				Form().setBasePath('detail').setItems([
					FormItem('distributionPeriodId', 'lookup').setVisible(isCreatable).setMandatory(true).setLookup('editableAffirmationDistributionPeriod').setWidth('420px'),
					FormItem('roleId', 'lookup').setMandatory(true).setVisible(isCreatable).setLookup('affirmationSubmissionPartyRole'),
					Cross().setVisible(isCreatable).setJustifyContent('right').setItems([
						Button('create', () => getPhrase('createNewSubmission')).setType('medium').setMargin('16px').setListener(async e => {
							const ctx = e.ctx;
							ctx.setModel(await ctx.getModel().saveDetail());
						})
					]),
					MessageDefinition(ctx => {
						if (isCreatable(ctx)) {
							return null;
						}
						return (
							<Message>{getPhrase('affirmationSubmissionCannotBeCreatedAtThisMoment')}</Message>
						);
					})
				])
			)
		).setVisible(ctx => !ctx.getProperty(['detail', 'id'])),
		Tab('basicInfo', () => getPhrase('basicInfo')).setContent(
			Centerer(
				Form().setBasePath('detail').setItems([
					MessageDefinition(ctx => {
						return <LatestStatus transitions={ctx.getProperty('transitions')}/>;
					}),
					FormItem('distributionPeriodId', 'lookup').setLookup('affirmationDistributionPeriod').setReadOnly(true).setWidth('540px'),
					FormItem('roleId', 'lookup').setReadOnly(true).setLookup('affirmationSubmissionPartyRole'),
					FormItem('isImported', 'lookup').setLookup('ynBoolean').setReadOnly(true).setLabel(ctx => getFormItemLabel('importedFromExcel')),
					MessageDefinition(ctx => {
						const stats = getTotalStats(ctx);
						return (
							<DisclaimerWrapper margin="16px 0px">
								{renderTotalTable(stats)}
							</DisclaimerWrapper>
						);
					}),
					Cross().setJustifyContent('right').setItems([
						FileInput('importFromExcel', () => getPhrase('importFromExcel'))
							.setType('medium')
							.onChange(importAffirmationAttachment),
					]).setVisible(ctx => !ctx.getRootProperty(['tmp', 'uploadButtonsHidden']) && !ctx.getRootProperty(['detail', 'readOnly'])),
				])
			)
		).setVisible(ctx => ctx.getProperty(['detail', 'id'])),
		Tab('conflictResolution', () => getPhrase('conflictResolution')).setContent(
			Form().setItems([
				MessageDefinition(ctx => {
					if (ctx.getRootProperty(['detail', 'conflictResolution', 'isOpen'])) {
						return null;
					}
					const willBeOpen = ctx.getRootProperty(['detail', 'conflictResolution', 'willBeOpen']);
					if (willBeOpen) {
						return <Message>{<span dangerouslySetInnerHTML={{__html: formatHtml(getPhrase('conflictResolutionWillBeOpen').replace('$fromDate', DateUtils.formatDate(ctx.getRootProperty(['detail', 'conflictResolution', 'fromDate']))))}}/>}</Message>;
					} else {
						return <Message>{<span dangerouslySetInnerHTML={{__html: formatHtml(getPhrase('conflictResolutionIsClosed'))}}/>}</Message>;
					}
				}),
				getSearchDefinition(
					'affirmationConflictResolution',
					'/api/dq/sv_affirmation_submission_conflict_resolution',
					[],
					'affirmationConflictResolution',
					['tmp'],
					true
				).setProps(resolutionProps).func('setProcessFilter', filter => {
					if (filter.title) {
						filter.title = filter.title.split(/[,;\.\s]+/g);
					}
					return filter;
				})
			])
		).setContentClassName('conflictResolution').setVisible(ctx => ctx.getRootProperty(['detail', 'conflictResolution', 'hasConflicts'])),
		Tab('cinemaAttendanceSearch', () => getFormItemLabel('cinemaAttendance')).setContent(
			getSearchDefinition(
				'affirmationCinemaAttendanceSearch',
				'/api/dq/sv_affirmation_cinema_attendance',
				[],
				'affirmationCinemaAttendance',
				['tmp'],
				true
			).setProps(searchTabProps).func('setProcessFilter', getNsndTokenFilterProcessor(['original_recording_name', 'recording_name']))
		).setVisible(searchTabVisible),
		Tab('broadcastSearch', () => getFormItemLabel('broadcast')).setContent(
			getSearchDefinition(
				'broadcastSearch',
				'/api/dq/sv_affirmation_broadcast',
				[],
				'affirmationBroadcast',
				['tmp'],
				true
			).setProps(searchTabProps).func('setProcessFilter', getNsndTokenFilterProcessor(['original_recording_name', 'recording_name']))
		).setVisible(searchTabVisible),
		Tab('saleSearch', () => getFormItemLabel('sale')).setContent(
			getSearchDefinition(
				'affirmationSaleSearch',
				'/api/dq/sv_affirmation_sale',
				[],
				'affirmationSale',
				['tmp'],
				true
			).setProps(searchTabProps)
		).setVisible(searchTabVisible),
		Tab('cinemaAttendance', () => getFormItemLabel('cinemaAttendance')).setContent(
			Form().setItems([
				TabularInput().setPath(['detail', 'cinemaAttendance']).setEntityName('affirmationCinemaAttendance').setKeySuffix(getTabularInputKeySuffix).setNoFilter(true).setHeaderTooltipPrefix('cinemaAttendance').setIndexTimestamp(getCinemaAttendanceIndexTimestamp).setItems([
					FormItem('title', 'lookup').setMandatory(true).setLabel(ctx => getFormItemLabel('recordingName'))
						.setFixedParams(ctx => {
							return {
								distributionPeriodId: ctx.getRootProperty(['detail', 'distributionPeriodId']),
							};
						})
						.setLookup('ufd')
						.setTimeout(300)
						.setFreeText(true)
						.setFreeTextPrefix(FREE_TEXT_PREFIX)
						.onChange(getLookupTitleChangeProcessor('ufd')),
					FormItem('releaseDate', 'date')
						.setWithTime(false)
						.setWidth('120px')
						.setReadOnly(true),
					FormItem('originalTitle', 'text')
						.setLabel(ctx => getFormItemLabel('originalRecordingName'))
						.setReadOnly(isCinemaAttendanceLocked),
					FormItem('productionYear', 'number')
						.setMandatory(true)
						.setWidth('100px')
						.setMaxDecimals(0)
						.setValidator(createProductionYearValidator()),
					FormItem('sharePct', 'number')
						.setMandatory(true)
						.setWidth('100px')
						.setMaxDecimals(4)
						.setValidator(ValueValidator(validateSharePct)),
					FormItem('isan', 'text').setWidth('330').setMaxLength(50),
					// FormItem('ufdAttendance', 'number').setWidth('120px').setMaxDecimals(0).setReadOnly(true),
					FormItem('attendance', 'number')
						.setMandatory(true)
						.setWidth('120px')
						.setMaxDecimals(0)
						.setValidator(ValueValidator(value => {
							if (value < 0) {
								return getPhrase('attendanceMustNotBeNegative');
							}
						}))
						.setReadOnly(isCinemaAttendanceLocked),
					createCorrectionInputDefinition(),
					FormItem('comments', 'comment').setWidth('24px').setLabel(''),
				])
					.setWithRowCountMessage(true)
					.setMargin('32px 0px')
					.setReadOnly(isSubmissionReadOnly)
					.setRowValidator(createCorrectionRowValidator())
					.setRowListValidator(ContextValidator((errors, ctx, itemName) => {
						if (itemName && itemName !== '_deleted') {
							return;
						}
						const rows = ctx.getData();
						if (!rows) {
							return;
						}
						let map = {};
						let dupl = [];
						rows.forEach((row, index) => {
							errors.add(
								ctx.getFullPath().concat([index, 'title']),
								null,
								'duplicate'
							);
							if (row.get('_deleted')) {
								return;
							}
							const key = normalizeTitle(row.get('title')) + '/' + row.get('productionYear');
							let ex = map[key];
							if (ex) {
								if (typeof ex === 'number') {
									ex = [ex, index];
								} else {
									ex.push(index);
								}
								dupl.push({
									title: row.get('title'),
									indexes: ex
								});
							} else {
								map[key] = index;
							}
						});
						dupl.forEach(d => {
							d.indexes.forEach(i => {
								errors.add(
									ctx.getFullPath().concat([i, 'title']),
									{
										type: 'error',
										code: 'duplicate',
										message: getPhrase('duplicateEntry'),
										longMessage: getPhrase('duplicateCinemaAttendanceEntries').replace('$duplicates', d.title),
									}
								);
							});

						});
					})),
				Cross().setItems([
					Button('copyMoviesFromPreviousYear', () => getPhrase('copyMoviesFromPreviousYear')).setType('medium').setListener(e => {
						const ctx = e.ctx;
						getCopyOfPreviousCinemaAttendances(ctx);
					}).setTooltipKey('copyMoviesFromPreviousYear'),
				]).setVisible(ctx => !ctx.getRootProperty(['detail', 'readOnly'])),
			])
		).setVisible(editTabVisible),
		Tab('broadcast', () => getFormItemLabel('broadcast')).setContent(
			Form().setItems([
				TabularInput().setPath(['detail', 'broadcasts']).setEntityName('affirmationBroadcast').setKeySuffix(getTabularInputKeySuffix).setNoFilter(true).setHeaderTooltipPrefix('broadcast').setIndexTimestamp(getBroadcastIndexTimestamp).setItems([
					FormItem('title', 'lookup').setMandatory(true).setLabel(ctx => getFormItemLabel('recordingName'))
						.setFixedParams(ctx => {
							return {
								distributionPeriodId: ctx.getRootProperty(['detail', 'distributionPeriodId']),
							};
						})
						.setFreeText(true)
						.setLookup('pressdata')
						.setFreeTextPrefix(FREE_TEXT_PREFIX)
						.setTimeout(300)
						.onChange(async (ctx, me, value) => {
							const attrs = lookupTitleChangeProcessor.pressdata.attributes;
							//['channel', 'broadcastStartTime', 'runtime', 'productionYear', 'affirmationRecordingTypeId']
							const pt = parseTitle(value);
							const title = pt.title;
							ctx.setProperty('comments', '');
							ctx.setProperty('correction', '');
							ctx.setProperty('attachments', EMPTY_LIST);

							if (pt.freeText) {
								ctx.setProperty('title', title);
								ctx.setProperty('isUnlocked', 'Y');
							} else {
								ctx.setProperty('title', title);
								ctx.setProperty('isUnlocked', 'N');
								const aggRowId = parseInt(pt.attributes[0]);
								const newRows = await webapi.execute('/api/proc/api_affirmations/getPressdataAggRows', {
									distributionPeriodId: ctx.getRootProperty(['detail', 'distributionPeriodId']),
									aggRowId
								});

								if (newRows === REPORTED_EXCEPTION) {
									return;
								}
								if (newRows[0]) {
									copyAttributesToRow(ctx, attrs, newRows[0]);
								}

								if (newRows.length > 1) {
									const rowPath = ['detail', 'broadcasts'];
									let currRows = ctx.getRootProperty(rowPath) || EMPTY_LIST;
									ctx.setRootProperty(rowPath, currRows.concat(Immutable.fromJS(newRows.slice(1).map(row => {
										row.isUnlocked = 'N';
										return row;
									}))));
									updateBroadcastIndexTimestamp(ctx);
								}
							}
						}),
					FormItem('originalTitle', 'text')
						.setLabel(ctx => getFormItemLabel('originalRecordingName'))
						.setReadOnly(isBroadcastLocked),
					FormItem('productionYear', 'number')
						.setValidator(createProductionYearValidator())
						.setMandatory(true)
						.setWidth('70px')
						// validateProductionYear(ctx, year
						.onChange((itemCtx, me, value) => {
							if (!validateProductionYear(itemCtx, value)) {
								const me = itemCtx.getData();
								const ctx = itemCtx.getParent();
								const title = itemCtx.getProperty('title');
								ctx.updateData(true);
								ctx.setData(ctx.getData().map(row => {
									if (row === me) {
										return row;
									}
									if (typeof row.get('productionYear') === 'number') {
										return row;
									}
									if (row.get('title') !== title) {
										return row;
									}
									return row.set('productionYear', value);
								}));
								updateBroadcastIndexTimestamp(ctx);
							}
						})
						.setMaxDecimals(0),
					FormItem('sharePct', 'number')
						.setMandatory(true)
						.setValidator(ValueValidator(validateSharePct))
						.setWidth('80px')
						.onChange((itemCtx, me, value) => {
							if (!validateSharePct(value)) {
								const me = itemCtx.getData();
								const ctx = itemCtx.getParent();
								const title = itemCtx.getProperty('title');
								ctx.updateData(true);
								ctx.setData(ctx.getData().map(row => {
									if (row === me) {
										return row;
									}
									if (typeof row.get('sharePct') === 'number') {
										return row;
									}
									if (row.get('title') !== title) {
										return row;
									}
									return row.set('sharePct', value);
								}));
								updateBroadcastIndexTimestamp(ctx);
							}
						})
						.setMaxDecimals(4),
					FormItem('affirmationRecordingTypeId', 'lookup').setMandatory(true).setLookup('affirmationRecordingType').setWidth('230px').setReadOnly(isBroadcastLocked),
					FormItem('channel', 'lookup').setMandatory(true).setLookup('affirmationChannel').setWidth('170px').setReadOnly(isBroadcastLocked),
					FormItem('broadcastStartTime', 'date').setWidth('190px').setMaxDecimals(0).setWithTime(true).setReadOnly(isBroadcastLocked),
					FormItem('runtime', 'number')
						.setValidator(ValueValidator(validateRuntime))
						.setMandatory(true)
						.setWidth('70px')
						.setLabel(ctx => getFormItemLabel('runtimeMinutes'))
						.setMaxDecimals(2)
						.onChange((itemCtx, me, value) => {
							if (!validateRuntime(value)) {
								const me = itemCtx.getData();
								const ctx = itemCtx.getParent();
								const title = itemCtx.getProperty('title');
								ctx.updateData(true);
								ctx.setData(ctx.getData().map(row => {
									if (row === me) {
										return row;
									}
									if (typeof row.get('runtime') === 'number') {
										return row;
									}
									if (row.get('title') !== title) {
										return row;
									}
									return row.set('runtime', value);
								}));
								updateBroadcastIndexTimestamp(ctx);
							}
						})
						.setReadOnly(isBroadcastLocked),
					createCorrectionInputDefinition(),
					FormItem('comments', 'comment').setWidth('24px').setLabel(''),
				])
					.setRowValidator(createCorrectionRowValidator())
					.setWithRowCountMessage(true)
					.setMargin('32px 0px')
					.setReadOnly(ctx => ctx.getRootProperty(['detail', 'readOnly'])),
				Cross().setItems([
					Button('updateFromCinemaAttendance', () => getPhrase('updateBroadcastsFromCinemaAttendance')).setType('medium').setListener(e => {
						const ctx = e.ctx;
						updateBroadcastsFromCinemaAttendance(ctx);
					}).setTooltipKey('updateBroadcastsFromCinemaAttendance'),
				]).setVisible(ctx => !ctx.getRootProperty(['detail', 'readOnly'])),
			])
		).setVisible(editTabVisible),
		Tab('sale', () => getFormItemLabel('sale')).setContent(
			Form().setItems([
				TabularInput().setPath(['detail', 'sales']).setEntityName('affirmationSale').setIndexTimestamp(getSaleIndexTimestamp).setNoFilter(true).setHeaderTooltipPrefix('sale').setKeySuffix(getTabularInputKeySuffix).setItems([
					FormItem('title', 'text').setMandatory(true).setLabel(ctx => getFormItemLabel('recordingName')),
					FormItem('affirmationRecordingTypeId', 'lookup').setMandatory(true).setLookup('affirmationRecordingType').setWidth('230px'),
					FormItem('productionYear', 'number').setValidator(createProductionYearValidator()).setMandatory(true).setWidth('70px').setMaxDecimals(0),
					FormItem('sharePct', 'number').setValidator(ValueValidator(validateSharePct)).setMandatory(true).setWidth('80px').setMaxDecimals(4),

					FormItem('physicalSaleIncome', 'number')
						.setWidth('160px')
						.setValidator(ValueValidator(value => {
							if (value < 0) {
								return getPhrase('cellError.invalidAmount');
							}
						}))
						.setMaxDecimals(4),
					FormItem('digitalSaleIncome', 'number')
						.setWidth('160px')
						.setValidator(ValueValidator(value => {
							if (value < 0) {
								return getPhrase('cellError.invalidAmount');
							}
						}))
						.setMaxDecimals(4),

					FormItem('currency', 'lookup').setMandatory(true).setLookup('affirmationCurrency').setWidth('80px'),
					/*createCorrectionInputDefinition({
						width: '80px',
						noAttachments: true,
						text: getFormItemLabel('note'),
						noSubtext: true,
						header: getFormItemLabel('note'),
						optional: true
					}),*/
					FormItem('comments', 'comment').setWidth('24px').setLabel(''),
				]).setWithRowCountMessage(true).setMargin('32px 0px').setReadOnly(ctx => ctx.getRootProperty(['detail', 'readOnly'])),
				Cross().setItems([
					Button('updateSalesFromCinemaAttendanceAndBroadcasts', () => getPhrase('updateSalesFromCinemaAttendanceAndBroadcasts')).setType('medium').setListener(e => {
						const ctx = e.ctx;
						updateSalesFromCinemaAttendanceAndBroadcasts(ctx);
					}).setTooltipKey('updateSalesFromCinemaAttendanceAndBroadcasts'),
				]).setVisible(ctx => !ctx.getRootProperty(['detail', 'readOnly'])),
			])
		).setVisible(editTabVisible),
	]),
	getCorrectionMessageDefinition(),
	getImportErrorDialog(),
	// getImportErrorDialog('pressdata', stgPressdataCustomResultProps),
]);




function getDetailForSave(detail, originalDetail) {
	const res = processModifications(originalDetail, detail);
	return res;
}

async function saveForLater(ctx) {
	ctx.setRootProperty(['detail', 'submit'], false);
	ctx.setModel(await ctx.getModel().saveDetail());
}


const getTotalBroadcastRuntime = memoizeOne(rows => {
	let res = 0;
	if (rows) {
		rows.forEach(row => {
			res += row.get('runtime') || 0;
		});
	}
	return res;
});

const getTotalCinemaAttendance = memoizeOne(rows => {
	let res = 0;
	if (rows) {
		rows.forEach(row => {
			res += row.get('attendance') || 0;
		});
	}
	return res;
});



const getTotalSales = memoizeOne(rows => {
	const physical = {};
	const digital = {};
	if (rows) {
		rows.forEach(row => {
			const p = row.get('physicalSaleIncome');
			const d = row.get('digitalSaleIncome');
			const curr = row.get('currency');
			if (!curr) {
				return;
			}
			if (p) {
				physical[curr] = (physical[curr] || 0) + p;
			}
			if (d) {
				digital[curr] = (digital[curr] || 0) + d;
			}
		});
	}
	return {
		physical: totalSaleMap2Array(physical),
		digital: totalSaleMap2Array(digital)
	};
});

const getSavedStats = memoizeOne(detail => {
	let res = (detail.get('savedStats') || EMPTY_MAP).toJS();
	if (!res.physicalSales) {
		res.physicalSales = [];
	}
	if (!res.digitalSales) {
		res.digitalSales = [];
	}
	return res;
});

function getTotalStats(ctx) {
	const data = ctx.getRootProperty('detail');
	let res;

	if (data.get('isImported') === 'Y') {
		res = getSavedStats(data);
	} else {
		const sales = getTotalSales(data.get('sales'));
		res = {
			cinemaAttendance: getTotalCinemaAttendance(data.get('cinemaAttendance')),
			physicalSales: sales.physical,
			digitalSales: sales.digital,
			broadcastRuntime: getTotalBroadcastRuntime(data.get('broadcasts'))
		};
	}
	res.hasData = res.cinemaAttendance > 0 || res.broadcastRuntime > 0 || res.physicalSales.length > 0 || res.digitalSales.length > 0;
	return res;
}




function renderDisclaimerCZ(ctx) {
	const year = getDistributionYear(ctx);
	const stats = getTotalStats(ctx);
	return (
		<ul className='main'>
			<li>
				Prohlašuji, že jsem v rozsahu práv spravovaných INTERGRAM nositelem práv
				výrobce zvukově obrazového záznamu ve smyslu autorského zákona a jsem tak
				osobou oprávněnou uplatňovat nárok na odměnu vybranou INTERGRAM za rok <b>{year}</b>.
			</li>
			<li>
				Prohlašuji, že v období <b>od 1.1. do 31.12.{year}</b> byly zvukově obrazové záznamy
				uplatňované v tomto čestném prohlášení chráněny na území České republiky
				autorským zákonem (tj. jedná se o filmy vyrobené v zemích Evropského
				hospodářského prostoru) a současně byly na území České republiky:
				<ul className='inner'>
					<li>
						vysílány celoplošně terestricky v rámci multikanálových plnoformátových
						televizních skupin nebo
					</li>
					<li>
						prodávány na nosičích nebo
					</li>
					<li>
						prodávány digitálním prodejem nebo
					</li>
					<li>
						promítány v kinech
					</li>
				</ul>
			</li>
			<li>
				Potvrzuji správnost následujících údajů, rozhodných pro stanovení podílu z odměn:
				{renderTotalTable(stats)}
			</li>
			<li>
				Souhlasím s tím, že správnost veškerých uvedených údajů v tomto prohlášení může
				být překontrolována v prvotních dokladech pracovníkem Intergramu.
			</li>
			<li>
				Veškeré údaje uvedené v tomto prohlášení jsou důvěrné a slouží výlučně pro interní potřebu Intergramu.
			</li>
		</ul>
	);
}

function renderDisclaimerEN(ctx) {
	const year = getDistributionYear(ctx);
	const stats = getTotalStats(ctx);
	return (
		<ul className='main'>
			<li>
				I declare that, within the scope of rights managed by INTERGRAM, I am the holder of the producer’s rights
				to an audiovisual recording under the Copyright Act and thus a person entitled to claim the remuneration
				collected by INTERGRAM for the year <b>{year}</b>.
			</li>
			<li>
				I declare that in the period from <b>January 1 to December 31, {year}</b>, the audiovisual recordings
				covered by this declaration were protected in the territory of the Czech Republic
				by the Copyright Act (i.e., these are films produced in countries of the European Economic Area),
				and at the same time they were, within the territory of the Czech Republic:
				<ul className='inner'>
					<li>
						broadcast nationwide terrestrially as part of multi-channel, full-format television groups,
					</li>
					<li>
						sold on physical media,
					</li>
					<li>
						sold through digital distribution, or
					</li>
					<li>
						screened in cinemas.
					</li>
				</ul>
			</li>
			<li>
				I confirm the accuracy of the following data, which are decisive for determining the share of remuneration:
				{renderTotalTable(stats)}
			</li>
			<li>
				I agree that the accuracy of all the information provided in this declaration may be verified using
				original documents by an Intergram staff member.
			</li>
			<li>
			All the information contained in this declaration is confidential and is intended solely for Intergram’s internal use.
			</li>
		</ul>
	);
}

function renderDisclaimer(ctx, langId) {
	if (langId === 'EN') {
		return renderDisclaimerEN(ctx);
	} else {
		return renderDisclaimerCZ(ctx);
	}
}

async function fileSubmission(ctx) {
	const langId = getLanguageId();
	console.log(langId);
	let model = ctx.getModel();
	model = await model.validateAll({
		displayErrorMessages: true,
		validateAll: true
	});
	if (model.hasErrors()) {
		ctx.setModel(model);
		return;
	}
	const dlgRes = await showMessageBox(() => {
		return (
			<DisclaimerWrapper>
				{renderDisclaimer(ctx, langId)}
			</DisclaimerWrapper>
		);
	}, {type: 'confirm'});
	if (dlgRes !== 'yes') {
		return;
	}
	ctx.setRootProperty(['detail', 'submit'], true);
	ctx.setModel(await ctx.getModel().saveDetail());

}

function getDetailModel() {
	DefinitionUtils.setLabels(detailDefinition, 'affirmationSubmission');

	const detailModel = new EntityDetailModel()
		.setLoadUri('/api/proc/api_affirmations/getSubmissionDetail')
		.setSaveUri('/api/proc/api_affirmations/saveSubmission')
		.setDefinition(detailDefinition)
		.setProcessForSave(getDetailForSave)
		.setRightToolbar((ctx, params) => {
			const statusId = ctx.getRootProperty(['detail', 'statusId']);
			if (isSubmissionReadOnly(ctx) || !ctx.getRootProperty(['detail', 'id'])) {
				return (
					<>
						{
							statusId === 'SUBMITTED' && ctx.getRootProperty(['detail', 'submissionPeriodOpen']) && (
								<ButtonComponent
									text={getPhrase('reopen')}
									type='medium'
									onAction={async () => {
										const detail = ctx.getRootProperty('detail') || EMPTY_MAP;
										const res = await webapi.execute('/api/proc/api_affirmations/setStatus', {
											distributionPeriodId: detail.get('distributionPeriodId'),
											partyId: detail.get('partyId'),
											roleTypeId: detail.get('roleTypeId'),
											statusId: 'SAVED_FOR_LATER'
										});
										if (res === REPORTED_EXCEPTION) {
											return;
										}
										ctx.setModel(await ctx.getModel().reload());
									}}
								/>
							)
						}
						<StatusBubble className={statusId} marginLeft="16px">
							{ctx.getRootProperty(['detail', 'status'])}
						</StatusBubble>
					</>
				);
			} else {
				return (
					<>
						<ButtonComponent
							text={getPhrase('cancelSubmission')}
							type='medium'
							negative
							// disabled={!params.modified}
							onAction={async () => {
								const dlgRes = await showMessageBox(getPhrase('reallyCancelAffirmationSubmission'), {
									type: 'confirm',
									yesIsNegative: true
								});
								if (dlgRes !== 'yes') {
									return;
								}
								const detail = ctx.getRootProperty('detail') || EMPTY_MAP;
								const res = await webapi.execute('/api/proc/api_affirmations/setStatus', {
									distributionPeriodId: detail.get('distributionPeriodId'),
									partyId: detail.get('partyId'),
									roleTypeId: detail.get('roleTypeId'),
									statusId: 'CANCELLED'
								});
								if (res === REPORTED_EXCEPTION) {
									return;
								}
								ctx.setModel(await ctx.getModel().reload());
								updateEntityTimestamp('affirmationSubmission');
							}}
						/>
						<ButtonComponent
							text={getPhrase('saveForLater')}
							type='medium'
							disabled={!params.modified}
							onAction={() => {
								saveForLater(ctx);
							}}
						/>
						<ButtonComponent
							text={getPhrase('fileSubmission')}
							onAction={() => {
								fileSubmission(ctx);
							}}
						/>
						{
							statusId && statusId !== 'NEW' && statusId !== 'SAVED_FOR_LATER' && (
								<StatusBubble className={statusId} marginLeft="16px">
									{ctx.getRootProperty(['detail', 'status'])}
								</StatusBubble>
							)
						}
					</>
				);
			}
		})
		.setHeader(data => {
			const detail = data.get('detail') || EMPTY_MAP;
			const id = detail.get('id');
			return (
				<ModuleHeader>
					{
						id ? (
							<>
								<ModuleHeaderItem light>{detail.get('distributionPeriodId')}</ModuleHeaderItem>
								<ModuleHeaderItem>{detail.get('partyName')}</ModuleHeaderItem>
								<ModuleHeaderItem light>{detail.get('roleType')}</ModuleHeaderItem>
							</>
						) : (
							<ModuleHeaderItem>{getPhrase('newAffirmationSubmission')}</ModuleHeaderItem>
						)
					}
				</ModuleHeader>
			);
		})
		.setEntityName('affirmationSubmission');

	return detailModel;
}

let affirmationSubmissionItemTypeLookup = null;

function getAffirmationSubmissionItemType() {
	if (!affirmationSubmissionItemTypeLookup) {
		affirmationSubmissionItemTypeLookup = getLookup('affirmationSubmissionItemType');
	}
	return affirmationSubmissionItemTypeLookup;
}

const Title = styled.div`
	.year {
		opacity: 0.7;
		font-size: 80%;
		font-weight: 500;
	}
`;

const ConflictDetail = styled.div`
	.status {
		text-align: center;
		margin-top: 4px;
		font-weight: 500;
		.resolved {
			color: ${props => props.theme.okColor};

			.smile {
				font-weight: 18px;
			}
		}

		.passedToProducers {
			color: #0011A8;
		}
		.ignored {
			color: ${props => props.theme.errorColor};
		}
	}

	.buttons {
		text-align: center;
		.simpleButton {
			border-radius: 6px;
			padding: 1px 6px;
			margin-right: 16px;
			font-weight: 500;
			cursor: pointer;
			border: 1px solid;
			margin-top: 4px;
			display: inline-block;
			&:hover {
				text-decoration: underline;
			}
			&.positive {
				color: ${props => props.theme.okColor};
			}
			&.negative {
				color: ${props => props.theme.errorColor};
			}
		}
	}
`;

const DetailItem = styled.div`
	.id {
		opacity: 0.7;
		font-size: 80%;
		font-weight: 500;
	}
	.year {
		font-weight: 500;
		margin-right: 4px;
	}

	.name {
		margin-left: 4px;
	}

	.amount {
		font-weight: 500;
		margin-right: 4px;
	}
	.currency {
		font-weight: 500;
		opacity: 0.7;
		margin-right: 4px;
	}
	.share {
		min-width: 60px;
		font-weight: 500;
		margin-right: 4px;
		display: inline-block;
		text-align: right;
	}
`;

const conflictRowPath = ['tmp', 'affirmationConflictResolution', 'data', 'result', 'data', 'rows'];

let lastChangedShare = null;

const TotalShare = styled.div`
	font-weight: 500;
	&.error {
		color: ${props => props.theme.errorColor};
	}
	&.ok {
		color: ${props => props.theme.okColor};
	}
`;

const resolutionCustomResultProps = {
	cellRendererMap: {
		type: (cell, row) => {
			return cell + ' - ' + getPhrase(getAffirmationSubmissionItemType().getText(cell));
		},
		title: (cell, row) => {
			const productionYear = row.get('production_year');
			return (
				<Title>
					{cell} <span className='year'>({productionYear})</span>
				</Title>
			);
		},
		total_share_pct: (cell, row) => {
			const value = row.get('total_share_pct');
			return (
				<TotalShare className={value >= 0 && value <= 100 ? 'ok' : 'error'}>
					{formatShare(value)}
				</TotalShare>
			);
		},
		share_pct: (cell, row, colIndex, ctx, rowIndex) => {
			return (
				<NumberInput
					width="100%"
					value={NumberUtils.parseNumber(row.get('share_pct'))}
					key={row.get('inputKey') || 0}
					readOnly={!row.get('editable')}
					onChange={async value => {
						if (lastChangedShare && lastChangedShare.rowIndex === rowIndex && lastChangedShare.value === value) {
							return;
						}
						lastChangedShare = {
							rowIndex,
							value
						};
						if (typeof value === 'number' && value >= 0 && value <= 100) {
							console.log('jsem tu - proc 2x?');
							const ssr = await webapi.execute('/api/proc/api_affirmations/setConflictSharePct', {
								types: row.get('type'),
								distPeriodId: row.get('distribution_period_id'),
								titleNsnd3: row.get('title_nsnd3'),
								partyId: row.get('party_id'),
								roleTypeId: row.get('role_type_id'),
								sharePct: value,
							});
							if (ssr === REPORTED_EXCEPTION) {
								const rows = ctx.getData().getIn(conflictRowPath);
								const inputKey = rows.getIn([rowIndex, 'inputKey']) || 0;
								ctx.setRootProperty(conflictRowPath, rows.setIn([rowIndex, 'inputKey'], inputKey + 1));
								return;
							}
							const rs = await webapi.execute('/api/dq/sv_affirmation_submission_conflict_resolution', {
								id: row.get('id')
							});
							if (rs === REPORTED_EXCEPTION || rs.rows.length !== 1) {
								const rows = ctx.getData().getIn(conflictRowPath);
								const inputKey = rows.getIn([rowIndex, 'inputKey']) || 0;
								ctx.setRootProperty(conflictRowPath, rows.setIn([rowIndex, 'inputKey'], inputKey + 1));
								return;
							}
							const rows = ctx.getData().getIn(conflictRowPath);
							ctx.setRootProperty(conflictRowPath, rows.set(rowIndex, Immutable.fromJS(rs.rows[0])));
						} else {
							const rows = ctx.getData().getIn(conflictRowPath);
							const inputKey = rows.getIn([rowIndex, 'inputKey']) || 0;
							ctx.setRootProperty(conflictRowPath, rows.setIn([rowIndex, 'inputKey'], inputKey + 1));
						}
						// console.log('ctx = ', .toJS());
					}}
					maxDecimals={2}
				/>
			);
		},
		detail: (cell, row) => {
			if (!cell) {
				return '';
			}
			const isResolved = row.get('is_resolved');
			const isPublic = row.get('is_public');
			return (
				<ConflictDetail>
					{
						cell.map((item, index) => {
							return (
								<DetailItem key={index}>
									<span className='share'>{formatShare(item.get('sharePct'))}%</span>
									-
									<span className='name'>{item.get('partyName')} <span className='id'>({item.get('partyId')})</span></span>
								</DetailItem>
							);
						})
					}
					<div className='status'>
						{
							isResolved === 'Y' && (
								<div className='resolved'>{getPhrase('resolved')}</div>
							)
						}
					</div>
				</ConflictDetail>
			);
		}
	},
	defaultColumnWidths: {
		'type': '200px',
		'total_share_pct': '120px',
		'share_pct': '120px',
	},
	columnAlign: {
		share_pct: 'right',
		total_share_pct: 'right',
	},
	columnFilters: {
		share_pct: {
			type: 'number',
			inputSize: 3
		},
		total_share_pct: {
			type: 'number',
			inputSize: 3
		},
		type: {
			type: 'lookup',
			lookup: 'affirmationSubmissionItemType'
		},
		title: {
			type: 'text'
		},
		detail: {
			type: 'lookup',
			lookup: 'submissionResolution'
		}
	}
};

function processSearchFilter(filter) {
	if (filter.role_id) {
		const pr = parseRoleId(filter.role_id);
		filter.party_id = pr?.partyId;
		filter.role_id = null;
	}
	return filter;
}

